import React from "react";
import StrokeIcon from "./StrokeIcon";

/** Locations: a map pin. Was the Service Areas icon until 2026-10-01. */
export default function LocationsIcon(props?: any) {
  return (
    <StrokeIcon iconProps={props}>
      {() => (
        <>
          <path d="M9 16.6s-5.4-5.2-5.4-9.2a5.4 5.4 0 0 1 10.8 0c0 4-5.4 9.2-5.4 9.2z" />
          <circle cx="9" cy="7.4" r="2" />
        </>
      )}
    </StrokeIcon>
  );
}
